import { Platform } from 'react-native'
import { web } from '../../../appVersion.js'
import Constants from 'expo-constants'

export const DEVELOPING = 'dev'
export const STAGING = 'stage'
export const PRODUCTION = 'prod'
export const ENVIROMENT = DEVELOPING
export const PREFIX = ''

export function getPrefix(slug) {
    let prefix = ''
    switch (slug) {
        case 'dots':
            prefix = ''
            break
        case 'sky-lambdatg':
            prefix = 'sky_'
            break
        case 'kimberly-one':
            prefix = 'kc_'
            break
        case 'bardahl-bardahlteconecta':
            prefix = ''
            break
        case 'salesbook-one':
            prefix = 'salesbook_'
            break
        case 'wwp-winwiththepartner':
            prefix = 'wwp_'
            break
        case 'salesbook-one':
            prefix = 'salesbook_'
        case 'jti-connect':
            prefix = 'jti_'
            break
        case 'shell-somosprotagonistas':
            prefix = 'sp_'
            break
        case 'danone-one':
            prefix = 'onels_'
            break
        case 'beiersdorf-wts':
            prefix = 'wts_'
            break
        case 'cocacola-gob':
            prefix = 'gob_'
            break
        case 'mars-betthertogether':
            prefix = 'mars_'
            break
        case 'savencia-one':
            prefix = 'savencia_'
            break
        case 'finlink-one':
            prefix = 'finlink_'
            break
        case 'one-mitsubishi':
            prefix = 'mitsubishi_'
            break
        case 'mercado-rural':
            prefix = 'mercado_'
            break
        case 'aura-one':
            prefix = 'aura_'
            break
        case 'lesaffre-one':
            prefix = 'lesaffre_'
            break
        case 'pos-one':
            prefix = 'pos_'
            break
        case 'one-pfizer':
            prefix = 'pfizer_'
            break
        case 'branca-one':
            prefix = 'branca_'
            break
        case 'axum-one':
            prefix = 'axum_'
            break
        case 'one-turbo':
            prefix = 'turbo_'
            break
        case 'one-axion':
            prefix = 'axion_'
            break
        case 'one-megalabs':
            prefix = 'megalabs_'
            break
        default:
            prefix = ''
            break
    }
    return prefix
}
export function getAppVersion() {
    let version = ''
    const expoConfig = Constants.expoConfig || {} // Usar expoConfig en lugar de manifest

    const platformOS = Platform.OS
    switch (platformOS) {
        case 'android':
            version = expoConfig.version
            break
        case 'ios':
            version = expoConfig.ios?.buildNumber
            break
        default:
            version = web.version
            break
    }

    return version
}

export function formatearFechaArgentina(fecha) {
    const diasSemana = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
    ]
    const meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ]

    const diaSemana = diasSemana[fecha.getDay()]
    const dia = fecha.getDate()
    const mes = meses[fecha.getMonth()]
    const año = fecha.getFullYear()

    return `${diaSemana} ${dia} de ${mes} de ${año}`
}
export const SEND_REQUEST_STATUS = {
    //sendRequest
    OK: 1,
    ERROR: 0,
}

export const SIDEBARFULLWIDTH = 200
export const SIDEBARSMALLWIDTH = 72
export const SIDEBARDEFAULTMARGIN = 28
export const WEBHEADERHEIGHT = 60

const expoConfig = Constants.expoConfig || { slug: '' }

export const isSP = expoConfig?.slug === 'shell-somosprotagonistas'
export const isBranca = expoConfig?.slug === 'branca-one'
export const isAxion = expoConfig?.slug === 'one-axion'
export const isMars = expoConfig?.slug === 'mars-betthertogether'
export const isKC = expoConfig?.slug === 'kimberly-one'
export const isDanone = expoConfig?.slug === 'danone-one'
export const isDots = expoConfig?.slug === 'dots-ii'
export const isSavencia = expoConfig?.slug === 'savencia-one'
export const isMegalabs = expoConfig?.slug === 'one-megalabs'
